var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "vue", "../Shared/KendoDataExtracter", "./BasicViewControllerWithCRUDDataSource"], function (require, exports, vue_1, KendoDataExtracter_1, BasicViewControllerWithCRUDDataSource_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var RepeaterController = (function (_super) {
        __extends(RepeaterController, _super);
        function RepeaterController(options_) {
            return _super.call(this, options_) || this;
        }
        RepeaterController.prototype.initVue = function () {
            var _this = this;
            var base = this;
            var vue = new vue_1.default({
                el: this.options.htmlElementSelector,
                data: {
                    model: [],
                    showModal: false,
                    modal: {
                        message: ''
                    },
                    textSearchValue: '',
                    itemsVisible: 0,
                    filter: {}
                },
                components: {
                    'modal': {
                        template: '#modal-template',
                    }
                },
                computed: {
                    filtered_model: function () {
                        var ret = [];
                        for (var _i = 0, _a = this.model; _i < _a.length; _i++) {
                            var item = _a[_i];
                            var filterArray = [item.Name, item.Comment];
                            if (item.SerialNumber) {
                                filterArray.push(item.SerialNumber);
                            }
                            if (this.complex_filter(item) && this.filterItem(filterArray)) {
                                ret.push(item);
                            }
                        }
                        return ret;
                    }
                },
                methods: {
                    filterItem: function (itemTextArray) {
                        try {
                            var textSearchValue = _this.vueRoot.textSearchValue.trim();
                            if (textSearchValue == '') {
                                return true;
                            }
                            else {
                                var itemText = itemTextArray.join(" ").toLocaleLowerCase();
                                if (_this.multiSearchAnd(itemText, textSearchValue.toLowerCase().split(" ")))
                                    return true;
                                else
                                    return false;
                            }
                        }
                        catch (e) {
                            console.log("error @ RepeaterController.filterItem: " + e);
                        }
                        return true;
                    },
                    multiSearchAnd: function (text, searchWords) {
                        var currTest;
                        while (currTest = searchWords.pop()) {
                            if (!text.match(new RegExp(currTest, "i")))
                                return false;
                        }
                        return true;
                    },
                    checkObject: function (object, filter) {
                        if (isNaN(object) && isNaN(filter) && typeof object === 'number' && typeof filter === 'number') {
                            return true;
                        }
                        if (object === filter) {
                            return true;
                        }
                        if ((typeof object === 'function' && typeof filter === 'function') ||
                            (object instanceof Date && filter instanceof Date) ||
                            (object instanceof RegExp && filter instanceof RegExp) ||
                            (object instanceof String && filter instanceof String) ||
                            (object instanceof Number && filter instanceof Number)) {
                            return object.toString() === filter.toString();
                        }
                        if (object instanceof Object && filter instanceof Object) {
                            for (var key in filter) {
                                return _this.vueRoot.checkObject(object[key], filter[key]);
                            }
                        }
                        return false;
                    },
                    complex_filter: function (item) {
                        for (var filter in _this.vueRoot.filter) {
                            if (!_this.vueRoot.checkObject(item, _this.vueRoot.filter[filter])) {
                                return false;
                            }
                        }
                        return true;
                    },
                    showItem: function (itemTextArray) {
                        var show = _this.filterItem(itemTextArray);
                        return show;
                    },
                    Update: function (event) {
                        if (_this.vueRoot.model.length !== undefined) {
                            for (var i = 0; i < _this.vueRoot.model.length; i++) {
                                KendoDataExtracter_1.KendoDataExtracter.SetKendoDatasourceEntryFromObject(_this.vueRoot.model[i], _this.remoteDataSource.at(i));
                            }
                        }
                        else {
                            KendoDataExtracter_1.KendoDataExtracter.SetKendoDatasourceEntryFromObject(_this.vueRoot.model, _this.remoteDataSource.at(0));
                            if (_this.options.IsInEditMode)
                                _this.remoteDataSource.at(0).dirty = true;
                        }
                        _this.remoteDataSource.sync();
                    },
                    ShowConfirm: function () {
                        this.showModal = true;
                    },
                    CloseConfirm: function () {
                        this.showModal = false;
                    },
                    DsGetNewInstanceOfType: function (type) {
                        return base.GetNewInstanceOfType(type);
                    }
                }
            });
            this.vueRoot = vue;
            window.$vue = vue;
        };
        RepeaterController.prototype.initRemoteDatasource = function () {
            var _this = this;
            var base = this;
            this.remoteDataSource = new kendo.data.DataSource({
                transport: {
                    read: {
                        url: null,
                        type: "get", dataType: "json", contentType: "application/json"
                    },
                    create: {
                        url: null,
                        type: "post", dataType: "json", contentType: "application/json"
                    },
                    update: {
                        url: null,
                        type: "put", dataType: "json", contentType: "application/json"
                    },
                    destroy: {
                        url: null,
                        type: "get", dataType: "json", contentType: "application/json"
                    },
                    parameterMap: function (data, operation) {
                        if (operation !== "read" && data) {
                            return kendo.stringify(data);
                        }
                    }
                },
                schema: {
                    type: "json",
                    model: {
                        id: "Id",
                        fields: { Id: "Id" }
                    }
                },
                change: function (e) {
                    if (e.items.length !== undefined) {
                        _this.vueRoot.model = [];
                        for (var i = 0; i < e.items.length; i++)
                            _this.vueRoot.model.push(KendoDataExtracter_1.KendoDataExtracter.GetPlainDataFromKendoDatasourceEntry(e.items[i]));
                    }
                    else
                        base.vueRoot.model = KendoDataExtracter_1.KendoDataExtracter.GetPlainDataFromKendoDatasourceEntry(e.items[0]);
                },
                requestEnd: function (e) {
                    _this.DSReqestEndHandler(e);
                    _this.FireEvent("dsRequestEnd");
                },
                error: function (e) {
                    _this.DSErrorHandler(e);
                }
            });
            (this.remoteDataSource.options.transport.create).url = this.options.createApiUrl;
            (this.remoteDataSource.options.transport.read).url = this.options.readApiUrl;
            (this.remoteDataSource.options.transport.update).url = this.options.updateApiUrl;
            (this.remoteDataSource.options.transport.destroy).url = this.options.destroyApiUrl;
            if (this.options.IsInEditMode)
                this.remoteDataSource.fetch(function () {
                    console.log(base.remoteDataSource.hasChanges());
                });
            else {
                var newInstance = this.GetNewInstanceOfType(this.options.type);
                if (this.options.tenantId != undefined && newInstance.hasOwnProperty("TenantId"))
                    newInstance.TenantId = this.options.tenantId;
                this.remoteDataSource.add(newInstance);
            }
        };
        RepeaterController.prototype.filterItem = function (itemTextArray) {
            try {
                var textSearchValue = this.vueRoot.textSearchValue.trim();
                if (textSearchValue == '') {
                    return true;
                }
                else {
                    var itemText = itemTextArray.join(" ").toLocaleLowerCase();
                    if (this.multiSearchAnd(itemText, textSearchValue.toLowerCase().split(" ")))
                        return true;
                    else
                        return false;
                }
            }
            catch (e) {
                console.log("error @ RepeaterController.filterItem: " + e);
            }
            return true;
        };
        RepeaterController.prototype.multiSearchAnd = function (text, searchWords) {
            var currTest;
            while (currTest = searchWords.pop()) {
                if (!text.match(new RegExp(currTest, "i")))
                    return false;
            }
            return true;
        };
        return RepeaterController;
    }(BasicViewControllerWithCRUDDataSource_1.BasicViewControllerWithCRUDDataSource));
    exports.RepeaterController = RepeaterController;
    $(function () {
        var optionsList = window["RepeaterControllerData"];
        for (var i in optionsList) {
            window["RepeaterController" + i] = new RepeaterController(optionsList[i]);
        }
    });
});
//# sourceMappingURL=RepeaterController.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Controllers/RepeaterController.js
// module id = 399
// module chunks = 0